import { Component, Input } from '@angular/core';

@Component({
    selector: 'pdf-wrapper',
    templateUrl: './pdf-wrapper.component.html',
    styleUrls: ['./pdf-wrapper.component.scss'],
})
export class PdfWrapperComponent {
    @Input() src!: any;
}
